import { useEffect, useState } from 'react';

import { usePathname } from '@/navigation';

import useFeature from './useFeature';
import { useIsDesktop } from './useIsDesktop';

export const useChatbotVisibility = () => {
  const pathname = usePathname();

  const isDesktop = useIsDesktop();

  const [isDisabled, setIsDisabled] = useState(true);

  const enableAda = Boolean(useFeature('retention-enable-ada'));

  // disabledPagesOverride absolute override zendesk for these pages:
  const disabledPagesOverride: string[] = ['product-recalls'];

  const isDisabledPage = disabledPagesOverride.some((url) =>
    pathname?.includes(url),
  );

  const loadChatForMobilePaths: string[] = ['/account', '/pages/help'];

  const loadForMobile = loadChatForMobilePaths.reduce((prev, current) => {
    if (pathname === '/') return prev;

    return pathname?.includes(current) ? [...prev, current] : prev;
  }, [] as string[]);

  /*
    live chat widget is enabled only for
    - US only
    - all desktop pages
    - all mobile pages for Ada
      - only certain mobile pages, as denoted in the loadChatForMobilePaths array.
    - can be disabled on a store basis by revoking the env variable value.

    ** - disabledPagesOverride overrides a page for desktop and mobile
  */
  useEffect(() => {
    setIsDisabled(
      isDisabledPage || (!isDesktop && !loadForMobile.length && !enableAda),
    );
  }, [pathname, isDesktop, loadForMobile, isDisabledPage, enableAda]);

  return { isDisabled, isDesktop };
};
